import { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";

import "./table.css";
import {
  filterTextTemplate,
  filterDateTemplate,
  filterGenderTemplate,
  filterAgeUnitTemplate,
  filterDropdownTemplate,
} from "./tableTemplate";
import {
  allSites,
  completeRecommendation,
  myEventReports,
  riskEventReports,
} from "./tableHandler";
import { LoadingProps } from "../../screens/all-sites/all-sites";

export default function Table(props: any) {
  const filterTemplate = {
    filterTextTemplate: filterTextTemplate,
    filterDateTemplate: filterDateTemplate,
    filterGenderTemplate: filterGenderTemplate,
    filterAgeUnitTemplate: filterAgeUnitTemplate,
    filterDropdownTemplate: filterDropdownTemplate,
  } as any;
  // const dateFilterTemplate = {
  //   filterDateTemplate: filterDateTemplate,
  // } as any;
  const tableHandler = {
    allSites: allSites,
    myEventReports: myEventReports,
    completeRecommendation: completeRecommendation,
    riskEventReports: riskEventReports,
  } as any;

  const attachmentFields = [
    "attachmentName",
    "modifiedBy",
    "modifiedDate",
    "analysis",
  ];
  const pageLimit = JSON.parse(sessionStorage.getItem("pageLimit") || "null");
  const pageNo = JSON.parse(sessionStorage.getItem("pageNo") || "null");
  const pageFirst = JSON.parse(sessionStorage.getItem("pageFirst") || "null");
  const sortedColumn = sessionStorage.getItem("sortedColumn");
  const sortOrder = JSON.parse(sessionStorage.getItem("sortOrder") || "{}");
  if (sortedColumn !== null && attachmentFields.includes(sortedColumn)) {
    sessionStorage.setItem("isAscending", JSON.stringify(false));
    sessionStorage.setItem("sortOrder", JSON.stringify(-1));
  }
  if (props.screen === "riskEventReports") {
    sessionStorage.setItem("sortedColumn", "riskReviewStatus");
  }

  const [totalRec, settotalRec] = useState(props.totalRec ?? 0);
  const [rowData, setrowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtered, setfiltered] = useState(false);
  const [reqParams, setreqParams] = useState({
    first: pageFirst,
    page: pageNo,
    limit: pageLimit,
    sortField: "",
    sortedColumn: "eventReportId",
    sortOrder: null,
    isAscendingOrder: false,
    dosFromDate: null,
    dosToDate: null,
    search: props.search,
  });

  // change filter funnel icon style based on conditions
  var filterStyleClassName = document.getElementsByClassName(
    "p-column-filter-menu-button"
  );
  const filterWithFillClassName = "pi pi-filter-icon pi-filter-fill";
  const filterWithoutFillClassName = "pi pi-filter-icon pi-filter";

  const filterEventId = JSON.parse(
    sessionStorage.getItem("eventReportId") || "{}"
  );
  const filterSiteName = JSON.parse(sessionStorage.getItem("siteName") || "{}");
  const filterSub = JSON.parse(sessionStorage.getItem("subCategory") || "{}");
  const filterService = JSON.parse(
    sessionStorage.getItem("serviceLine") || "{}"
  );
  const filterGender = JSON.parse(sessionStorage.getItem("gender") || "{}");
  const filterAge = JSON.parse(sessionStorage.getItem("age") || "{}");
  const filterAgeUnit = JSON.parse(sessionStorage.getItem("ageUnit") || "{}");
  const filterStatus = JSON.parse(sessionStorage.getItem("status") || "{}");
  const filterReviewStatus = JSON.parse(
    sessionStorage.getItem("reviewStatus") || "{}"
  );
  const filterRegion = JSON.parse(sessionStorage.getItem("region") || "{}");
  const filterDOS = sessionStorage.getItem("dos");
  const filterRiskStatus = JSON.parse(
    sessionStorage.getItem("riskReviewStatus") || "{}"
  );

  const [filters, setFilters] = useState(null);
  const rowsPerPageOptions = [25, 50, 100, 250, 500];
  useEffect(() => {
    var filterJson = {} as any;
    for (let i = 0; i < props.column.length; i++) {
      const element = props.column[i];
      if (element.filter !== false) {
        if (element.filterType !== "date") {
          filterJson[element.field] = {
            constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
            operator: FilterOperator.AND,
          };
        } else {
          filterJson[element.field] = {
            constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            operator: FilterOperator.AND,
          };
        }
      }
    }
    if (filterEventId !== null && filterJson.hasOwnProperty("eventReportId")) {
      filterStyleClassName[0].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      filterJson.eventReportId.constraints[0].value = filterEventId;
    }
    if (filterSiteName !== null && filterJson.hasOwnProperty("siteName")) {
      filterStyleClassName[2].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      filterJson.siteName.constraints[0].value = filterSiteName;
    }
    if (filterSub !== null && filterJson.hasOwnProperty("subCategory")) {
      filterStyleClassName[3].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      filterJson.subCategory.constraints[0].value = filterSub;
    }
    if (filterService !== null && filterJson.hasOwnProperty("serviceLine")) {
      filterStyleClassName[4].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      filterJson.serviceLine.constraints[0].value = filterService;
    }
    if (filterGender !== null && filterJson.hasOwnProperty("gender")) {
      filterStyleClassName[5].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      filterJson.gender.constraints[0].value = filterGender;
    }
    if (filterAge !== null && filterJson.hasOwnProperty("age")) {
      filterStyleClassName[6].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      filterJson.age.constraints[0].value = filterAge;
    }
    if (filterAgeUnit !== null && filterJson.hasOwnProperty("ageUnit")) {
      filterStyleClassName[7].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      filterJson.ageUnit.constraints[0].value = filterAgeUnit;
    }
    if (filterStatus !== null && filterJson.hasOwnProperty("status")) {
      filterStyleClassName[8].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      filterJson.status.constraints[0].value = filterStatus;
    }
    if (
      filterReviewStatus !== null &&
      filterJson.hasOwnProperty("reviewStatus")
    ) {
      filterStyleClassName[9].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      filterJson.reviewStatus.constraints[0].value = filterReviewStatus;
    }
    if (filterRegion !== null && filterJson.hasOwnProperty("region")) {
      filterStyleClassName[10].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      filterJson.region.constraints[0].value = filterRegion;
    }
    if (filterDOS !== null && filterJson.hasOwnProperty("dos")) {
      filterStyleClassName[1].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      filterJson.dos.constraints[0].value = filterDOS;
    }
    if (
      filterRiskStatus !== null &&
      filterJson.hasOwnProperty("riskReviewStatus")
    ) {
      filterStyleClassName[11].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      filterJson.riskReviewStatus.constraints[0].value = filterRiskStatus;
    }
    setFilters(filterJson);
    if (props.reloadData) {
      props.reloadData(loadData);
    }
  }, []);
  useEffect(() => {
    loadData();
  }, [reqParams, props.reloadTable, props.search]);

  useEffect(() => {
    if (props.rows) {
      setrowData(props.rows);
      setLoading(false);
      // props.setFilterLoader(false);
    }
  }, [props]);

  const loadData = () => {
    if (props.setShowLoader) {
      props.setShowLoader((prev: LoadingProps) => ({
        ...prev,
        table: false,
      }));
    }
    if (props.setShowLoader1) {
      props.setShowLoader1(true);
    }
    if (!props.rows) {
      // setLoading(true);
      var data = null;
      if (props.screen === "completeRecommendation") {
        var type = props.popupName === "Primary Review" ? 1 : 2;
        data = {
          eventReportId: props.eventReportId,
          type,
        };
      } else {
        data = reqParams;
        if (props.search != null) {
          data.search = props.search;
        }
      }
      tableHandler[props.screen](data)
        .then((res: any) => {
          setrowData(res.data);
          settotalRec(res.totalCount);
          setLoading(false);
          props.setFilterLoader(false);
          if (
            props.screen === "myEventReports" ||
            props.screen === "riskEventReports"
          ) {
            props.setShowLoader1(false);
          }

          if (props.setShowLoader) {
            props.setShowLoader((prev: LoadingProps) => ({
              ...prev,
              table: true,
            }));
          }
        })
        .catch((e: any) => console.log(e));
    }
  };

  const onPage = (event: any) => {
    var setReq = { ...reqParams } as any;
    setReq.first = event.first;
    setReq.page = event.first / event.rows;
    setReq.limit = event.rows;
    sessionStorage.setItem("pageLimit", JSON.stringify(setReq.limit));
    sessionStorage.setItem("pageNo", JSON.stringify(setReq.page));
    sessionStorage.setItem("pageFirst", JSON.stringify(setReq.first));
    setreqParams(setReq);
  };

  const onSort = (event: any) => {
    if (sortOrder === 1) {
      event.sortOrder = -1;
    }
    var setReq = { ...reqParams } as any;
    setReq.first = pageFirst;
    setReq.page = pageNo;
    setReq.limit = pageLimit;
    setReq.sortField =
      event.sortField === null ? reqParams.sortField : event.sortField;
    setReq.sortOrder =
      event.sortOrder === 0
        ? reqParams.sortOrder === -1
          ? 1
          : -1
        : event.sortOrder;
    setReq.sortedColumn =
      event.sortField === null ? reqParams.sortField : event.sortField;
    setReq.isAscendingOrder = event.sortOrder === -1 ? false : true;
    sessionStorage.setItem(
      "isAscending",
      JSON.stringify(setReq.isAscendingOrder)
    );
    sessionStorage.setItem("sortedColumn", setReq.sortField);
    sessionStorage.setItem("sortOrder", setReq.sortOrder);
    setreqParams(setReq);
  };

  const GetDate = (dt: Date) => {
    var dt = new Date(dt);
    var offset = dt.getTimezoneOffset() * 60 * 1000;
    var withOffset = dt.getTime();
    var withoutOffset = withOffset - offset;
    var newDate = new Date(withoutOffset);
    var utcDate = newDate.toISOString();
    return utcDate;
  };

  const onFilter = (event: any) => {
    let eventReportIdValue = event.filters.eventReportId.constraints[0].value;
    let siteNameValue = event.filters.siteName.constraints[0].value;
    let subCategoryValue = event.filters.subCategory.constraints[0].value;
    let serviceLineValue = event.filters.serviceLine.constraints[0].value;
    let genderValue = event.filters.gender.constraints[0].value;
    let ageValue = event.filters.age.constraints[0].value;
    let ageUnitValue = event.filters.ageUnit.constraints[0].value;
    let statusValue = event.filters.status.constraints[0].value;
    let reviewStatusValue = event.filters.reviewStatus.constraints[0].value;
    let regionValue = event.filters.region.constraints[0].value;
    let dosValue = event.filters.dos.constraints[0].value;

    if (eventReportIdValue === null) {
      filterStyleClassName[0].getElementsByTagName("span")[0].className =
        filterWithoutFillClassName;
      sessionStorage.setItem("eventReportId", JSON.stringify(null));
    } else {
      filterStyleClassName[0].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      sessionStorage.setItem(
        "eventReportId",
        JSON.stringify(eventReportIdValue)
      );
    }
    if (siteNameValue === null) {
      filterStyleClassName[2].getElementsByTagName("span")[0].className =
        filterWithoutFillClassName;
      sessionStorage.setItem("siteName", JSON.stringify(null));
    } else {
      filterStyleClassName[2].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      sessionStorage.setItem("siteName", JSON.stringify(siteNameValue));
    }
    if (subCategoryValue === null) {
      filterStyleClassName[3].getElementsByTagName("span")[0].className =
        filterWithoutFillClassName;
      sessionStorage.setItem("subCategory", JSON.stringify(null));
    } else {
      filterStyleClassName[3].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      sessionStorage.setItem("subCategory", JSON.stringify(subCategoryValue));
    }
    if (serviceLineValue === null) {
      filterStyleClassName[4].getElementsByTagName("span")[0].className =
        filterWithoutFillClassName;
      sessionStorage.setItem("serviceLine", JSON.stringify(null));
    } else {
      filterStyleClassName[4].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      sessionStorage.setItem("serviceLine", JSON.stringify(serviceLineValue));
    }
    if (genderValue === null) {
      filterStyleClassName[5].getElementsByTagName("span")[0].className =
        filterWithoutFillClassName;
      sessionStorage.setItem("gender", JSON.stringify(null));
    } else {
      filterStyleClassName[5].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      sessionStorage.setItem("gender", JSON.stringify(genderValue));
    }
    if (ageValue === null) {
      filterStyleClassName[6].getElementsByTagName("span")[0].className =
        filterWithoutFillClassName;
      sessionStorage.setItem("age", JSON.stringify(null));
    } else {
      filterStyleClassName[6].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      sessionStorage.setItem("age", JSON.stringify(ageValue));
    }
    if (ageUnitValue === null) {
      filterStyleClassName[7].getElementsByTagName("span")[0].className =
        filterWithoutFillClassName;
      sessionStorage.setItem("ageUnit", JSON.stringify(null));
    } else {
      filterStyleClassName[7].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      sessionStorage.setItem("ageUnit", JSON.stringify(ageUnitValue));
    }
    if (statusValue === null) {
      filterStyleClassName[8].getElementsByTagName("span")[0].className =
        filterWithoutFillClassName;
      sessionStorage.setItem("status", JSON.stringify(null));
    } else {
      filterStyleClassName[8].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      sessionStorage.setItem("status", JSON.stringify(statusValue));
    }
    if (reviewStatusValue === null) {
      filterStyleClassName[9].getElementsByTagName("span")[0].className =
        filterWithoutFillClassName;
      sessionStorage.setItem("reviewStatus", JSON.stringify(null));
    } else {
      filterStyleClassName[9].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      sessionStorage.setItem("reviewStatus", JSON.stringify(reviewStatusValue));
    }
    if (regionValue === null) {
      filterStyleClassName[10].getElementsByTagName("span")[0].className =
        filterWithoutFillClassName;
      sessionStorage.setItem("region", JSON.stringify(null));
    } else {
      filterStyleClassName[10].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
      sessionStorage.setItem("region", JSON.stringify(regionValue));
    }
    if (dosValue === null) {
      sessionStorage.removeItem("dos");
      sessionStorage.removeItem("dosFromDate");
      sessionStorage.removeItem("dosToDate");
      filterStyleClassName[1].getElementsByTagName("span")[0].className =
        filterWithoutFillClassName;
    } else {
      sessionStorage.setItem("dos", JSON.stringify(dosValue));
      filterStyleClassName[1].getElementsByTagName("span")[0].className =
        filterWithFillClassName;
    }
    if (props.screen === "riskEventReports") {
      let riskStatusValue =
        event.filters?.riskReviewStatus?.constraints[0].value;

      if (riskStatusValue === null) {
        filterStyleClassName[11].getElementsByTagName("span")[0].className =
          filterWithoutFillClassName;
        sessionStorage.setItem("riskReviewStatus", JSON.stringify(null));
      } else {
        filterStyleClassName[11].getElementsByTagName("span")[0].className =
          filterWithFillClassName;
        sessionStorage.setItem(
          "riskReviewStatus",
          JSON.stringify(riskStatusValue)
        );
      }
    }

    var maxDate = new Date();
    var splitDOSFromDate;
    var splitDOSToDate;
    if (event.filters.dos.constraints[0].value !== null) {
      var splitDatesDOS = event.filters.dos.constraints[0].value.split(":");
      splitDatesDOS[0] === "undefined"
        ? (splitDOSFromDate = new Date("01/01/1755"))
        : (splitDOSFromDate = GetDate(splitDatesDOS[0]));
      splitDatesDOS[1] === "undefined"
        ? (splitDOSToDate = new Date())
        : (splitDOSToDate = GetDate(splitDatesDOS[1]));
      // if(splitDatesDOS[0] === "undefined"){
      //   x1 = new Date("01/01/1000");
      // } else{
      //   x1 = new Date(splitDatesDOS[0]);
      // }
      // if(splitDatesDOS[1] === "undefined"){
      //   x2 = new Date();
      // } else{
      //   x2 = new Date(splitDatesDOS[1]);
      // }
      sessionStorage.setItem("dosFromDate", JSON.stringify(splitDOSFromDate));
      sessionStorage.setItem("dosToDate", JSON.stringify(splitDOSToDate));
    } else {
      splitDOSFromDate = null;
      splitDOSToDate = null;
      sessionStorage.setItem("dosFromDate", JSON.stringify(splitDOSFromDate));
      sessionStorage.setItem("dosToDate", JSON.stringify(splitDOSToDate));
    }
    // console.log(x1,x2);
    var filteredCheck = false;
    var setReq = { ...reqParams } as any;
    for (var key in event.filters) {
      if (key !== null && key !== "null") {
        if (
          event.filters[key].constraints[0].value !== "" &&
          event.filters[key].constraints[0].value !== null
        ) {
          filteredCheck = true;
        }
        if (
          event.filters[key].constraints[0].value !== "" &&
          event.filters[key].constraints[0].value !== null
        ) {
          setReq[key] =
            event.filters[key].constraints[0].value === "null"
              ? ""
              : event.filters[key].constraints[0].value;
        } else {
          setReq[key] = null;
        }
      }
    }
    setReq.first = 0;
    setReq.page = 0;
    setReq.limit = pageLimit;
    sessionStorage.setItem("pageLimit", JSON.stringify(setReq.limit));
    sessionStorage.setItem("pageNo", JSON.stringify(setReq.page));
    setReq.dosFromDate = splitDOSFromDate;
    setReq.dosToDate = splitDOSToDate;
    // sessionStorage.setItem("dosFromDate",JSON.stringify(setReq.dosFromDate))
    // sessionStorage.setItem("dosToDate", JSON.stringify(setReq.dosToDate))
    // if(event.filters.dos.constraints[0].value !== null){
    //   if(event.filters.dos.constraints[0].value.slice(-1) === "a"){
    //     event.filters.dos.constraints[0].value = event.filters.dos.constraints[0].value.slice(0,-1);
    //     setReq.dosFromDate = event.filters.dos.constraints[0].value;
    //     if(setReq.dosToDate === null && setReq.dosFromDate !== null){
    //       setReq.dosToDate = new Date().toString();
    //     } else{
    //       setReq.dosToDate = null;
    //     }
    //   } else if(event.filters.dos.constraints[0].value.slice(-1) === "b"){
    //     event.filters.dos.constraints[0].value = event.filters.dos.constraints[0].value.slice(0,-1);
    //     setReq.dosToDate = event.filters.dos.constraints[0].value;
    //   }
    //   // event.filters.dos.constraints[0].value = event.filters.dos.constraints[0].value.slice(0,-1);
    //   // setReq.dosFromDate = event.filters.dos.constraints[0].value;
    // } else if(event.filters.dos.constraints[0].value === null){
    //   setReq.dosFromDate= null;
    //   setReq.dosToDate = null;
    // }
    // setReq.dosFromDate = event.filters.dos.constraints[0].value;
    // if(setReq.dosToDate === null && setReq.dosFromDate !== null){
    //   setReq.dosToDate = new Date();
    // } else{
    //   setReq.dosToDate = null;
    // }
    setfiltered(filteredCheck);
    setreqParams(setReq);
    setLoading(true);
    props.setFilterLoader(true);
  };

  const columns = props.column;
  const dynamicColumns = columns.map((col: any, i: any) => {
    return (
      <Column
        field={col.field}
        header={col.header}
        body={col.body ? col.body : null}
        filter={col.filter === false ? false : true}
        sortable={col.sortable === false ? false : true}
        filterElement={(e: any) => {
          //col.filterType == 'date' ? dateFilterTemplate[col.filterElement] :
          if (col.filterElement) {
            if (col.filterElement === "filterDropdownTemplate") {
              return filterTemplate[col.filterElement](
                e,
                col.dropDownOptions,
                col.dropDownName,
                col.dropDownValue
              );
            } else {
              return filterTemplate[col.filterElement](e);
            }
          } else {
            return null;
          }
        }}
        filterType={col.filterType ? col.filterType : null}
        showFilterMatchModes={col.showFilterMatchModes ? true : false}
        showFilterMenuOptions={col.showFilterMenuOptions ? true : false}
        showFilterOperator={col.showFilterOperator ? true : false}
        dataType={col.dataType ? col.dataType : null}
        style={{ width: `${col.width ? col.width : "auto"}` }}
        align={col.align ? col.align : "left"}
      />
    );
  });

  return (
    <>
      <DataTable
        // OTHERS
        value={rowData}
        lazy={props.lazy}
        // loading={loading}
        // STYLING
        size="small"
        stripedRows
        responsiveLayout="scroll"
        emptyMessage="No records found"
        //SORTING
        sortField={reqParams.sortField}
        sortOrder={reqParams.sortOrder}
        removableSort
        // PAGINATION
        paginator={
          totalRec <= rowsPerPageOptions[0]
            ? false
            : filtered && totalRec <= reqParams.limit
            ? false
            : props.pagination
        }
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={reqParams.limit}
        totalRecords={totalRec}
        rowsPerPageOptions={rowsPerPageOptions}
        first={reqParams.first}
        //FILTER
        filters={filters as any}
        //EVENTS
        onPage={onPage}
        onSort={onSort}
        onFilter={props.defaultFilter ? undefined : onFilter}
        globalFilterFields={["siteName"]}
      >
        {dynamicColumns}
      </DataTable>
    </>
  );
}
